import React, {AriaRole, useEffect, useRef, useState} from 'react'
import {useAppSelector} from '../../../app/hooks';
import {kompetenceCardReducer, KompetenceCardState} from '../../../pages/kompetencerPage/cards/kompetenceCardSlice';
import {KlarmeldKompetenceButton} from './klarmeldKompetenceButton';
import {GodkendKompetenceButton} from './godkendKompetenceButton';
import {AccountService} from '../../../services/account/accountService';
import { LaegekompetenceMeta } from 'core/sharedmodels/kompetence/laegekompetenceMeta';

interface StatusButtonProps {
    brugerId?: string;
    buttonHandleCallback?: (godkender: boolean) => void;
    onSucceded?: (updatedLaegeKompetencer: LaegekompetenceMeta[]) => void;
    role?: AriaRole;
}

export function KompetenceStatusButton(props: StatusButtonProps) {
    const kompetenceCardState = useAppSelector(kompetenceCardReducer) as KompetenceCardState;
    const userService = new AccountService();
    const _currentUser = useRef(userService.getUser());

    const [showKlarmeldState, setShowKlarmeldState] = useState<boolean>(false);
    const [showGodkendState, setShowGodkendState] = useState<boolean>(false);

    const ShowKlarmeldButton = (): boolean => {
        return _currentUser.current.IsLaege();
    }
    const ShowGodkendButton = (): boolean => {
        return ((_currentUser.current.IsVejleder() || _currentUser.current.IsUddannelsesansvarlig() || _currentUser.current.IsAdminOrVus()) && (_currentUser.current.UserId !== props.brugerId));
    }

    useEffect(() => {
        setShowKlarmeldState(ShowKlarmeldButton());
        setShowGodkendState(ShowGodkendButton());
    }, [kompetenceCardState.activeLaegekompetenceMeta])

    const render = (
        <>
            {showKlarmeldState &&
                <KlarmeldKompetenceButton klarmelderCallback={props.buttonHandleCallback} onKlarmeldSucceeded={props.onSucceded} role={props.role}/>}

            {showGodkendState &&
                <GodkendKompetenceButton godkenderCallback={props.buttonHandleCallback} onGodkendSucceeded={props.onSucceded} role={props.role}/>}
        </>
    )

    return <>{render}</>
}
